export var AvatarSize;
(function (AvatarSize) {
    AvatarSize[AvatarSize["large"] = 48] = "large";
    AvatarSize[AvatarSize["default"] = 40] = "default";
    AvatarSize[AvatarSize["small"] = 32] = "small";
})(AvatarSize || (AvatarSize = {}));
export var AvatarFontSize;
(function (AvatarFontSize) {
    AvatarFontSize[AvatarFontSize["large"] = 16] = "large";
    AvatarFontSize[AvatarFontSize["default"] = 14] = "default";
    AvatarFontSize[AvatarFontSize["small"] = 12] = "small";
})(AvatarFontSize || (AvatarFontSize = {}));
export var AvatarBadgeSize;
(function (AvatarBadgeSize) {
    AvatarBadgeSize[AvatarBadgeSize["large"] = 8] = "large";
    AvatarBadgeSize[AvatarBadgeSize["default"] = 8] = "default";
    AvatarBadgeSize[AvatarBadgeSize["small"] = 6] = "small";
})(AvatarBadgeSize || (AvatarBadgeSize = {}));
export var BadgeRightIndent;
(function (BadgeRightIndent) {
    BadgeRightIndent[BadgeRightIndent["large"] = 3] = "large";
    BadgeRightIndent[BadgeRightIndent["default"] = 3] = "default";
    BadgeRightIndent[BadgeRightIndent["small"] = 2] = "small";
})(BadgeRightIndent || (BadgeRightIndent = {}));
export var BadgeBottomIndent;
(function (BadgeBottomIndent) {
    BadgeBottomIndent[BadgeBottomIndent["large"] = 3] = "large";
    BadgeBottomIndent[BadgeBottomIndent["default"] = 2] = "default";
    BadgeBottomIndent[BadgeBottomIndent["small"] = 2] = "small";
})(BadgeBottomIndent || (BadgeBottomIndent = {}));
//# sourceMappingURL=types.js.map